<div class="modal-header">
    <h4 class="modal-title">{{ isUpdateForm ? 'Update' : 'Add' }} Internal User ID</h4>
</div>
<div class="modal-body">
    <form [formGroup]="dynamicForm" class="form" novalidate autocomplete="off">
        <div class="form-group">
            <label for="internalId" class="form-label bold">Internal User ID</label>
            <cm-text-input
                id="internalId"
                formControlName="organizationProfileId"
                placeholder="Internal User ID"
                [ngClass]="{ 'is-invalid': !!dynamicForm.controls.organizationProfileId.errors && showErrors }"
                [maxlength]="255"
            >
            </cm-text-input>
        </div>
    </form>
    <div class="form-errors show-errors" *ngIf="showErrors">
        <p *ngFor="let error of errors">{{ error }}</p>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">Cancel</button>
    <button
        class="btn btn-primary"
        [disabled]="!dynamicForm.dirty || (!isUpdateForm && !dynamicForm.get('organizationProfileId').value)"
        type="button"
        (click)="onSave()"
    >
        Save
    </button>
</div>
